module.exports = __webpack_public_path__ + "assets/low.01f2f93d.svg";